export type ImageRenderMeta = {
  width: number;
  height: number;
};

const fixedMeta = (width: number, height: number): ImageRenderMeta => ({ width, height });

const IMAGE_META: Record<string, ImageRenderMeta> = {
  "/offer-path.webp": fixedMeta(900, 502),
  "/onboarding_lander_science.webp": fixedMeta(900, 502),
  "/romain_skyline.webp": fixedMeta(900, 491),
  "/romain_skyline.avif": fixedMeta(900, 491),
  "/roman_republic.webp": fixedMeta(900, 491),
  "/pirate_engineering.webp": fixedMeta(900, 590),
  "/pirate_engineering.avif": fixedMeta(900, 590),
  "/science_lightspeed.webp": fixedMeta(900, 491),
  "/roman_gladiators.webp": fixedMeta(900, 491),
  "/pysch_representation.webp": fixedMeta(900, 502),
  "/pysch_representation.avif": fixedMeta(900, 502),
  "/science_ac.webp": fixedMeta(900, 491),
  "/history_julius_caesar.webp": fixedMeta(900, 491),
  "/high_court.webp": fixedMeta(900, 491),
  "/science_preindustrial_engineering.webp": fixedMeta(900, 491),
  "/science_chemicals.webp": fixedMeta(1100, 600),
  "/noah_ark_confidence.webp": fixedMeta(2752, 1536),
  "/moses_egypt_confidence.webp": fixedMeta(2752, 1536),
  "/david_goliath_confidence.webp": fixedMeta(2752, 1536),
  "/jesus_death_confidence.webp": fixedMeta(2752, 1536),
  "/path_failure_affirmation.webp": fixedMeta(2752, 1536),
  "/family_12_week_journey.webp": fixedMeta(2752, 1536),
  "/parents_not_alone.webp": fixedMeta(2752, 1536),
  "/journey.avif": fixedMeta(1000, 511),
  "/what_we_can_do.avif": fixedMeta(950, 530),
  "/persona_shepard.webp": fixedMeta(1100, 575),
  "/persona_disciple.webp": fixedMeta(1100, 575),
  "/persona_wanderer.webp": fixedMeta(1100, 575),
  "/persona_scribe.webp": fixedMeta(1100, 614),
  "/persona_prophet.webp": fixedMeta(1100, 575),
  "/persona_berean.webp": fixedMeta(1100, 614),
  "/characters_v2_1.webp": { width: 500, height: 809 },
  "/characters_v2_2.webp": { width: 500, height: 750 },
  "/characters_v2_3.webp": { width: 500, height: 757 },
  "/characters_v2_4.webp": { width: 500, height: 732 },
  "/hands_bible.webp": fixedMeta(1376, 768)
};

export const getImageRenderMeta = (src?: string | null): ImageRenderMeta | undefined => {
  if (!src) {
    return undefined;
  }
  return IMAGE_META[src];
};

export const getImagePreloadCandidates = (src?: string | null): string[] => {
  if (!src) {
    return [];
  }

  return [src];
};

export const getImagePreloadCandidatesForSources = (
  sources?: Array<string | null | undefined>
): string[] => {
  if (!sources || sources.length === 0) {
    return [];
  }

  return Array.from(new Set(sources.flatMap((source) => getImagePreloadCandidates(source))));
};
